<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Detalhes da Transportadora</p>
        </div>

        <div class="muven-content">
            <Breadcrumb :items="breadcrumbList" class="mb-3"/>

            <div class="mb-3" v-if="!loading">
                <a class="btn btn-outline-secondary"
                    :href="getAuditUrl(deliveryCompany.id, EntityEnum.DeliveryCompany)" target="_blank">
                    Ir para auditoria
                    <fa icon="external-link-alt" class="muven-external-link ml-1" />
                </a>
            </div>

            <Loading page v-if="loading" />            

            <div v-if="!loading">
                <div class="muven-card muven-card-md muven-card-centered">
                    <div class="muven-card-title">
                        <p>Transportadora</p>
                    </div>

                    <div>
                        <div class="mb-3">
                            <label>Nome</label>
                            <p>{{deliveryCompany.name}}</p>
                        </div>
                        <div>
                            <label>Status</label>
                            <p>
                                <span v-if="deliveryCompany.isActive">Ativa</span>
                                <span v-if="!deliveryCompany.isActive">Inativa</span>
                            </p>
                        </div>
                    </div>
                </div>                    
            </div>
        </div>
    </div>
</template>

<script>
import deliveryCompanyService from '@/delivery_company/services/DeliveryCompanyService'
import { infoOrPlaceholder } from '@/utils/filters/InformationOrPlaceholderFilter'
import { DeliveryCompanyModel } from '@/delivery_company/models/DeliveryCompanyModel'
import { EntityEnum } from '@c2b/muven-commons'
import GetAuditUrl from '@/utils/mixins/GetAuditUrl'

export default {
    name: 'DeliveryCompanyView',
    data() {
        return {
            EntityEnum,
            loading: true,
            deliveryCompany: new DeliveryCompanyModel(),
            breadcrumbList: [
                {
                    id: 0,
                    description: 'Transportadoras',
                    path: '/transportadoras',
                },
                {
                    id: 1,
                    description: `Detalhes de #${this.$route.params.id}`,
                    path: '',
                },
            ],    
        }
    },
    mixins: [
        GetAuditUrl,
    ],
    filters: {
        infoOrPlaceholder,
    },
    methods: {
        async allowExportModifiedInDeliveryCompany(allowExport) {
           try {
                await deliveryCompanyService.updateAllowExportInDeliveryCompany(this.deliveryCompany.id, allowExport)
           } catch (e) {
               this.$floatingAlert.error({
                   message: e.message,
               })
           }
       },
    },
    async mounted() {
        try {
            this.deliveryCompany = await deliveryCompanyService.getDeliveryCompanyById(this.$route.params.id)
        } catch (err) {
            this.$floatingAlert.error({
                message: err.message,
            })
        }

        this.loading = false
    },
}
</script>
